import {Component, Input} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";

@Component({
  selector: 'micro-airtimeProductFilter-detail',
  templateUrl: './airtimeProductFilter-detail.component.html'
})
export class AirtimeProductFilterDetailComponent extends BaseComponent {
  airtimeProductFilter:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/air/airtimeProductFilters/${id}`).subscribe(
            data => {
              this.airtimeProductFilter = data as any;
            }
          );
        }
      });
  }

  createNew() {
    this.airtimeProductFilter = {
      filter: '%'
    };
  }

  save() {
    if (!this.airtimeProductFilter.id) {
      this.http.post(`${this.env.e.url}/air/airtimeProductFilters`, this.airtimeProductFilter)
        .subscribe(
          data => {
            this.airtimeProductFilter = data;
            this.alertService.info(`Created ${this.airtimeProductFilter.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/air/airtimeProductFilters/${this.airtimeProductFilter.id}`, this.airtimeProductFilter)
        .subscribe(
          data => {
            this.airtimeProductFilter = data;
            this.alertService.info(`Updated ${this.airtimeProductFilter.name}`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/air/airtimeProductFilters/${this.airtimeProductFilter.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.airtimeProductFilter.name}`);
          this.router.navigate(["/air/airtimeProductFilters"]);
        }
      );
  }
}
